import { render, staticRenderFns } from "./detailed.vue?vue&type=template&id=fcaea98a&scoped=true&"
import script from "./detailed.vue?vue&type=script&lang=js&"
export * from "./detailed.vue?vue&type=script&lang=js&"
import style0 from "./detailed.vue?vue&type=style&index=0&id=fcaea98a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaea98a",
  null
  
)

export default component.exports